<template>
  <div
    v-b-popover.hover="tooltip"
    class="tooltip-wrapper"
  >
    <span class="fa fa-info-circle"></span>
  </div>
</template>
<script>
  import Vue from 'vue';
  import {Component} from 'vue-property-decorator';

  @Component
  export default class AdditionInfo extends Vue {
    tooltip = '';

    created() {
      this.tooltip = this.$slots.default[0].text;
    }
  }
</script>

<style scoped>
  .tooltip-wrapper {
    display: inline-block;
  }
</style>
